import React, {Component} from 'react';
import ZoneSelector from './zones'
import Map from './map'
import zoneCounter from './zoneCounter';

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      zoneChoice: 1
    }
    this.updateZone = this.updateZone.bind(this);
    this.printClass = this.printClass.bind(this)
  }

  updateZone(zone) {
    this.setState({ zoneChoice: zone })
  }

  standardMap() {
    document.querySelectorAll('.seat').forEach (
      function(seats) {
        seats.classList.add('PL2')
        seats.classList.remove('zoneLottery', 'zoneNotSold', 'PL1', 'PL3', 'PL4', 'PL5','PL6', 'PL7', 'PL8', 'PL9', 'PL11', 'PL10')
      }
    )
    document.querySelectorAll(
      '.N li, .O li, .M ul :nth-child(n+3):nth-child(-n+58), .L ul :nth-child(n+5):nth-child(-n+57)'
      ).forEach (
      function(seats) {
        seats.classList.add('PL3')
        seats.classList.remove('zoneLottery', 'zoneNotSold', 'PL1', 'PL2', 'PL4', 'PL5','PL6', 'PL7', 'PL8', 'PL9', 'PL11', 'PL10')
      }
    )  
    document.querySelectorAll(
      '.P li, .Q li, .R li'
      ).forEach (
      function(seats) {
        seats.classList.add('PL4')
        seats.classList.remove('zoneLottery', 'zoneNotSold', 'PL1', 'PL2', 'PL3', 'PL5','PL6', 'PL7', 'PL8', 'PL9', 'PL11', 'PL10')
      }
    )  
    document.querySelectorAll(
      '.TA li, .TB li, .TC ul :nth-child(n+18):nth-child(-n+50), .TD ul :nth-child(n+18):nth-child(-n+50) '
      ).forEach (
      function(seats) {
        seats.classList.add('PL5')
        seats.classList.remove('zoneLottery', 'zoneNotSold', 'PL1', 'PL2', 'PL3', 'PL4', 'PL6', 'PL7', 'PL8', 'PL8', 'PL11', 'PL10')
      }
    )  
    document.querySelectorAll(
      '.A ul :nth-child(-n+4), .A ul :nth-child(n+39), .B ul :nth-child(-n+4), .B ul :nth-child(n+42), .C ul :nth-child(-n+2), .C ul :nth-child(n+38), .D ul :nth-child(n+35), .E ul :nth-child(-n+8), .E ul :nth-child(n+46), .F ul :nth-child(-n+4), .F ul :nth-child(n+49), .G ul :nth-child(-n+4), .G ul :nth-child(n+50), .H ul :nth-child(-n+6), .H ul :nth-child(n+52), .I ul :nth-child(-n+4), .I ul :nth-child(n+47), .J ul :nth-child(n+41), .K ul :nth-child(-n+4), .K ul :nth-child(n+55), .L ul :nth-child(-n+4), .L ul :nth-child(n+58), .M ul :nth-child(-n+2), .M ul :nth-child(n+59), .S li, .T li, .U li, .V ul :nth-child(n+9):nth-child(-n+56), .W ul :nth-child(n+16):nth-child(-n+49)'
      ).forEach (
      function(seats) {
        seats.classList.add('PL6')
        seats.classList.remove('zoneLottery', 'zoneNotSold', 'PL1', 'PL2', 'PL3', 'PL4', 'PL5', 'PL7', 'PL8', 'PL9', 'PL11', 'PL10')
      }
    )    
    document.querySelectorAll(
      '.Y ul :nth-child(-n+14), .Y ul :nth-child(n+37), .TB ul :nth-child(-n+11), .TB ul :nth-child(n+55) , .TC ul :nth-child(n+11):nth-child(-n+17), .TD ul :nth-child(n+12):nth-child(-n+17), .TC ul :nth-child(n+50):nth-child(-n+56), .TD ul :nth-child(n+50):nth-child(-n+56), .TE ul :nth-child(n+12):nth-child(-n+55), .TF ul :nth-child(n+14):nth-child(-n+58), .TG ul :nth-child(n+11):nth-child(-n+56), .TH ul :nth-child(n+10):nth-child(-n+56), .TI ul :nth-child(n+11):nth-child(-n+56)'
      ).forEach (
      function(seats) {
        seats.classList.add('PL7')
        seats.classList.remove('zoneLottery', 'zoneNotSold', 'PL1', 'PL2', 'PL3', 'PL4', 'PL5','PL6', 'PL8', 'PL9', 'PL11', 'PL10')
      }
    )
    document.querySelectorAll(
      '.AA ul :nth-child(-n+6), .AA ul :nth-child(n+26), .BB ul :nth-child(-n+6), .BB ul :nth-child(n+31), .CC ul :nth-child(-n+6), .CC ul :nth-child(n+33), .X ul :nth-child(n+8):nth-child(-n+54), .V ul :nth-child(-n+8), .V ul :nth-child(n+57), .W ul :nth-child(n+7):nth-child(-n+16), .W ul :nth-child(n+50):nth-child(-n+59)'
      ).forEach (
      function(seats) {
        seats.classList.add('PL8')
        seats.classList.remove('zoneLottery', 'zoneNotSold', 'PL1', 'PL2', 'PL3', 'PL4', 'PL5','PL6', 'PL7', 'PL9', 'PL11', 'PL10')
      }
    ) 
    document.querySelectorAll(
      '.TJ li, .TK li, .TC ul :nth-child(n+7):nth-child(-n+11), .TD ul :nth-child(n+7):nth-child(-n+11), .TE ul :nth-child(n+7):nth-child(-n+11), .TF ul :nth-child(n+9):nth-child(-n+13), .TG ul :nth-child(n+6):nth-child(-n+10), .TH ul :nth-child(n+1):nth-child(-n+9), .TI ul :nth-child(n+1):nth-child(-n+10), .TC ul :nth-child(n+57):nth-child(-n+60), .TD ul :nth-child(n+57):nth-child(-n+60), .TE ul :nth-child(n+56):nth-child(-n+60), .TF ul :nth-child(n+59):nth-child(-n+63), .TG ul :nth-child(n+57):nth-child(-n+61), .TH ul :nth-child(n+57), .TI ul :nth-child(n+57)'
      ).forEach (
      function(seats) {
        seats.classList.add('PL9')
        seats.classList.remove('zoneLottery', 'zoneNotSold', 'PL1', 'PL2', 'PL3', 'PL4', 'PL5','PL6', 'PL7', 'PL8', 'PL11', 'PL10')
      }
    )   
    document.querySelectorAll(
      '.Z li, .Y li, .W ul :nth-child(-n+6), .W ul :nth-child(n+60), .X ul :nth-child(-n+7), .X ul :nth-child(n+55)'
      ).forEach (
      function(seats) {
        seats.classList.add('PL10')
        seats.classList.remove('zoneLottery', 'zoneNotSold', 'PL1', 'PL2', 'PL3', 'PL4', 'PL5','PL6', 'PL7', 'PL8', 'PL9', 'PL11')
      }
    )   
    document.querySelectorAll(
      '.Y ul :nth-child(-n+14), .Y ul :nth-child(n+37), .TC ul :nth-child(-n+7), .TC ul :nth-child(n+61), .TD ul :nth-child(-n+7), .TD ul :nth-child(n+61), .TE ul :nth-child(-n+6), .TE ul :nth-child(n+61), .TF ul :nth-child(-n+8), .TF ul :nth-child(n+64), .TG ul :nth-child(-n+5), .TG ul :nth-child(n+62)'
      ).forEach (
      function(seats) {
        seats.classList.add('PL11')
        seats.classList.remove('zoneLottery', 'zoneNotSold', 'PL1', 'PL2', 'PL3', 'PL4', 'PL5','PL6', 'PL7', 'PL8', 'PL9', 'PL10')
      }
    )  
    document.querySelectorAll(
      '.CC ul :nth-child(n+13):nth-child(-n+27), .A ul :nth-child(n+14):nth-child(-n+30), .B ul :nth-child(n+15):nth-child(-n+33), .C ul :nth-child(n+10):nth-child(-n+29), .D ul :nth-child(n+4):nth-child(-n+26), .E ul :nth-child(n+15):nth-child(-n+38), .F ul :nth-child(n+15):nth-child(-n+40), .G ul :nth-child(n+15):nth-child(-n+41), .H ul :nth-child(n+16):nth-child(-n+44)'
      ).forEach (
      function(seats) {
        seats.classList.add('PL1')
        seats.classList.remove('zoneLottery', 'zoneNotSold', 'PL2', 'PL3', 'PL4', 'PL5','PL6', 'PL7', 'PL8', 'PL9', 'PL11', 'PL10')
      }
    )  
    zoneCounter()
  }

  printClass() {
    document.body.classList.toggle('print')
    document.querySelectorAll('.zoneSelector li').forEach (
        function(zone) {
            if(zone.children[2].innerHTML === '0') {
                zone.style.display = 'none'
            }
            if(zone.className === "PL1" && zone.children[2].innerHTML === '2254') {
              zone.style.display = 'none'
            }
            if(document.body.className !== 'print') {
                zone.style.display = 'block'
            }
        }
    )
  }

  render() {
    return (
      <div>
        <ZoneSelector getUpdatedZone={this.updateZone} />
        <Map zoneChoice={this.state.zoneChoice} />
        <h1 className='title'>Cobb Great Hall
          <span>Wharton Center for Performing Arts</span>
        </h1>        
        <p className='stage'>Stage</p>
        <p className='orchLeft'>Orchestra Left</p>
        <p className='orchRight'>Orchestra Right</p>
        <p className='orch'>Orchestra</p>
        <p className='sound'>Sound Mix Position</p>
        <p className='tier'>Grand Tier</p>
        <p className='wheelchair'>Wheelchair</p>
        <p className='companion'>Companion Seats</p>
        <p className='ada'>ADA Swing Arm Seats</p>
        <p className="standard" onClick={this.standardMap}>Standard Map</p>
        <p className='printBTN' onClick={this.printClass}>Print</p>

      </div>
    )
  }
}

export default App;